import { MaterialDarkTheme } from "../.internal/themes/MaterialDarkTheme";
export default MaterialDarkTheme;
